import { render, staticRenderFns } from "./detail-report.vue?vue&type=template&id=6e149abc&scoped=true"
import script from "./detail-report.vue?vue&type=script&lang=js"
export * from "./detail-report.vue?vue&type=script&lang=js"
import style0 from "./detail-report.vue?vue&type=style&index=0&id=6e149abc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e149abc",
  null
  
)

export default component.exports